define('views/parts/form/textbox',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // templates
    'text!templates/parts/form/textbox.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // templates
    TTextBox
) {

    /**
     * Creates an input box with an inline dynamic label
     * and provides two-way binding via Epoxy.
     *
     * @param  {string} type of the input element
     * @param  {string} attribute of the model
     * @param  {string} name of the input element
     * @param  {string} id of the input element
     */

    var VTextBox = Backbone.Epoxy.View.extend({
        template: TTextBox,
        events: {
            'focus .form-control': 'onInputFocus',
            'blur .form-control': 'onInputBlur',
            'keyup .form-control': 'onKeyUp',
        },
        regions: {
            root: ".input-placeholder",
            label: ".control-label",
            input: ".form-control",
            addonBefore: ".input-group-addon.before",
            addonAfter: ".input-group-addon.after"
        },
        initialize: function(opt) {
            var model = this.model,
                options = this.options = _.extend({
                    type: "text",
                    name: opt.attribute,
                    labelposition: "inner",
                    id: this.cid,
                    validation: false,
                    needsTranslatedLabel: true,
                    validationMsg: true,
                    attribute: "value",
                    autofocus: false,
                }, opt);

            if (!model) {
                this.model = model = new Backbone.Model();
                model.set(options.attribute, null);
            }

            if (options.labelposition === "inner") {
                options.inner = true;
            }

            this.listenTo(model, "change:" + options.attribute, this.onChange);

            if (options.validation) {
                this.listenTo(model, "invalid:" + options.attribute, this.onInvalid);
                if (options.validationMsg) {
                    this.regions.error = ".error";
                }
            }

        },
        render: function() {

            var html = Mustache.render(this.template, Mustache.getContext(this.options));

            this.$el.empty().append(html);

            this.applyBindings();

            this.generateZones()
                .updateLabel();
            return this;
        },

        updateLabel: function() {
            if (this.zone && this.zone.$label) {
                var val = this.model.get(this.options.attribute);
                this.toggleLabel(_.isNumber(val) || !_.isEmpty(val));
            }
        },

        toggleLabel: function(val) {
            this.zone.$label.toggleClass("label-to-top", val);
        },

        getValue: function() {
            return this.model.get(this.options.attribute);
        },

        setValue: function(value, options) {
            this.model.set(this.options.attribute, value, options);
        },

        setLabel: function (label) {
            this.options.label = label;

            if (this.zone && this.zone.$label) {
                this.zone.$label.text(label);
            } else {
                this.render();
            }
        },

        setDisable: function(value) {
            this.zone.$input.prop('disabled', value);
        },

        setAddonAfter: function(value) {
            this.zone.$addonAfter.html(value);
        },

        setAddonBefore: function(value) {
            this.zone.$addonBefore.html(value);
        },

        setInputValue: function(value) {
            this.zone.$input.val(value);
        },

        setHelpText: function(value) {
          this.options.help = value;
        },

        getInputValue: function() {
            return this.zone.$input.val();
        },

        clearError: function() {
            var zone = this.zone;
            if (zone) {
                zone.$root.removeClass("has-error");
                if (zone.$error) {
                    zone.$error.html("");
                }
            }
        },

        ////////////
        // events //
        ////////////
        onChange: function(model, value, options) {
            this.updateLabel();
            this.trigger('change', value);
        },

        onInvalid: function (model, error, options) {
            var zone = this.zone;

            if (!zone) {
                return;
            }

            zone.$root.addClass("has-error");

            if (!this.options.validationMsg) {
                return;
            }

            var msg = this.options.validationMsg;

            if (typeof msg === "function") {
                msg = msg(model, error, options);
            } else if (typeof msg === "string") {
                msg = i18n.t(msg);
            } else {
                msg = i18n.t("general:" + error);
            }

            zone.$error.html(msg);
        },

        // form events
        onInputFocus: function(e) {
            this.toggleLabel(true);
            this.zone.$label.addClass("focus");
        },

        onInputBlur: function(e) {
            var zone = this.zone,
                value = zone.$input.val();

            zone.$label.removeClass("focus");
            if (value === "" || value === null) {
                this.toggleLabel(false);
            }
        },

        onKeyUp: function(e) {
            if (e.keyCode === 13) {
                this.trigger('submit', this.model, this.getValue());
            }
            // else {
            //     this.trigger('submit', this.model, this.getValue());
            // }
        },

    }, {
        ///////////////////////
        // Static properties //
        ///////////////////////
        create: function(label, model, attribute, type, options) {
            return new VTextBox(_.extend({
                label: label,
                model: model,
                attribute: attribute,
                type: type,
            }, options));
        }
    });

    return VTextBox;

});

